import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

interface Props {
  cancel(): void;
  proceed(poNumber: string): void;
}

const MAX_LENGTH = 10;
const PO_REGEX = /^[a-zA-Z0-9-_]*$/; // adjust if needed

export const PoNumberField: React.FC<Props> = (props) => {
  const [poNumber, setPoNumber] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (!PO_REGEX.test(value)) {
      setError("Only letters, numbers, - and _ are allowed");
      return;
    }

    setError("");
    setPoNumber(value);
  };

  const handleProceed = () => {
    props.proceed(poNumber.trim());
  };

  return (
    <>
      <DialogTitle>PO Number (optional)</DialogTitle>

      <DialogContent>
        <Typography>Enter the PO Number if available</Typography>

        <TextField
          fullWidth
          variant="outlined"
          value={poNumber}
          onChange={handleChange}
          name="poNumber"
          placeholder="Enter the PO Number here.."
          error={Boolean(error)}
          helperText={error || `${poNumber.length}/${MAX_LENGTH} characters`}
          inputProps={{
            maxLength: MAX_LENGTH,
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={props.cancel}>Skip</Button>
        <Button onClick={handleProceed} disabled={Boolean(error)}>
          Proceed
        </Button>
      </DialogActions>
    </>
  );
};
